// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"text-card_wrapper__K3JTF","theme-good-green":"text-card_theme-good-green__m08A8","theme-good-blue":"text-card_theme-good-blue__EfPsb"};